import {
  Alert,
  Button,
  DeleteIcon,
  LinkIcon,
  Menu,
  MoreIcon,
  Space,
} from "melco-ui";
import { Dropdown } from "antd";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { isEmpty } from "lodash";
import { useDeleteFonts } from "../../../hooks/libraries/fonts/useDeleteFonts";
import { FusionMelcoModelsUserAlphabet, useConfirm } from "melco-shared-logic";
import { useShouldShowWarning } from "../../../hooks/items/useShouldShowWarning";
import { Drawer as DrawerType } from "../../../hooks/drawer/useGenericDrawer";

type FontDetailMoreActionButtonProps = {
  font: FusionMelcoModelsUserAlphabet;
  referencesDrawer: DrawerType;
};

export const FontDetailMoreActionButton: React.FC<
  FontDetailMoreActionButtonProps
> = ({ font, referencesDrawer }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const deleteFonts = useDeleteFonts();
  const shouldShowWarning = useShouldShowWarning();

  const confirmDelete = useConfirm(
    async () => {
      //TODO: Handle case if font.id doesnt exist
      if (font.id) {
        const successfullyDeletedIds = await deleteFonts([font.id]);

        // redirect to list view in case the entity was deleted successfully
        if (!isEmpty(successfullyDeletedIds)) {
          navigate(`/libraries/fonts/embroidery`);
        }
      }
    },
    {
      translationPrefix: "fonts.actions.delete",
      translationOptions: {
        count: 1,
      },
      content: shouldShowWarning(font) && (
        <Space direction="vertical" size="small">
          {t("fonts.actions.delete.confirmation.message", {
            count: 1,
          })}
          <Alert
            type="warning"
            withBackground
            description={t("fonts.actions.delete.confirmation.warning", {
              count: 1,
            })}
            showIcon={false}
          />
        </Space>
      ),
    }
  );

  const MoreActions = (
    <Menu>
      <Menu.Item
        key="more-actions-references"
        onClick={() => {
          referencesDrawer.openDrawer();
        }}
      >
        <LinkIcon /> {t("fonts.actions.references.button")}
      </Menu.Item>
      <Menu.Item
        key="more-actions-delete"
        danger
        onClick={() => {
          confirmDelete();
        }}
      >
        <DeleteIcon /> {t("fonts.actions.delete.button")}
      </Menu.Item>
    </Menu>
  );

  return (
    <Dropdown
      overlay={MoreActions}
      trigger={["click"]}
      placement="bottomRight"
      arrow
    >
      <Button
        key="font-more-actions"
        icon={<MoreIcon />}
        data-cy-id="font-more-actions"
      />
    </Dropdown>
  );
};
